
import { useState } from 'react';

export default function MailchimpForm() {
  const handleJoinFounderCommunity = () => {
    // Abrir el enlace de Skool en una nueva pestaña
    window.open('https://www.skool.com/experiencia-neo-8010', '_blank');
  };

  return (
    <div className="bg-white rounded-3xl p-8 shadow-2xl border border-gray-200 max-w-2xl mx-auto">
      <div className="text-center mb-8">
        <div className="w-20 h-20 bg-gradient-to-r from-[#6607a5] to-purple-600 rounded-full flex items-center justify-center mx-auto mb-6">
          <i className="ri-group-line text-white text-4xl"></i>
        </div>
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4 text-center leading-tight">
          Únete a la Comunidad Fundadora
        </h2>
        <p className="text-lg text-gray-600 mb-6">
          Sé parte de la construcción de NEO desde el primer día
        </p>
      </div>

      {/* Beneficios destacados */}
      <div className="bg-gradient-to-br from-[#6607a5]/5 to-purple-600/5 rounded-2xl p-6 mb-8 border border-[#6607a5]/20">
        <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">
          🚀 Beneficios Exclusivos de Fundador
        </h3>
        <div className="space-y-3">
          <div className="flex items-start">
            <i className="ri-check-line text-[#6607a5] text-xl mr-3 mt-0.5"></i>
            <span className="text-gray-700"><strong>Participa en todas las decisiones</strong> - Ayuda a dar forma a cada detalle de la plataforma</span>
          </div>
          <div className="flex items-start">
            <i className="ri-check-line text-[#6607a5] text-xl mr-3 mt-0.5"></i>
            <span className="text-gray-700"><strong>Vive la construcción día a día</strong> - Acceso exclusivo al proceso de desarrollo</span>
          </div>
          <div className="flex items-start">
            <i className="ri-check-line text-[#6607a5] text-xl mr-3 mt-0.5"></i>
            <span className="text-gray-700"><strong>70% de descuento de por vida</strong> - Precio congelado para siempre</span>
          </div>
          <div className="flex items-start">
            <i className="ri-check-line text-[#6607a5] text-xl mr-3 mt-0.5"></i>
            <span className="text-gray-700"><strong>Acceso prioritario</strong> - Serás de los primeros en todo</span>
          </div>
          <div className="flex items-start">
            <i className="ri-check-line text-[#6607a5] text-xl mr-3 mt-0.5"></i>
            <span className="text-gray-700"><strong>Comunidad exclusiva</strong> - Conecta con otros fundadores visionarios</span>
          </div>
        </div>
      </div>

      {/* Oferta especial */}
      <div className="bg-gradient-to-r from-yellow-50 to-orange-50 rounded-2xl p-6 mb-8 border border-yellow-200">
        <div className="text-center">
          <div className="text-2xl font-bold text-gray-900 mb-2">
            🎯 Oferta Limitada
          </div>
          <div className="text-lg text-gray-700 mb-3">
            <span className="line-through text-gray-500">Precio regular: $49/mes</span>
          </div>
          <div className="text-3xl font-bold text-[#6607a5] mb-2">
            Fundadores: $19/mes
          </div>
          <div className="text-sm text-gray-600 font-medium">
            ⏰ Precio congelado de por vida · Solo para los primeros 25 fundadores
          </div>
        </div>
      </div>

      {/* CTA Principal */}
      <button
        onClick={handleJoinFounderCommunity}
        className="w-full bg-gradient-to-r from-[#6607a5] to-purple-700 hover:from-purple-700 hover:to-[#6607a5] text-white font-bold py-6 px-8 rounded-xl transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer text-lg flex items-center justify-center gap-3 mb-6 transform hover:scale-105"
      >
        <i className="ri-rocket-line text-2xl"></i>
        <span>UNIRME COMO FUNDADOR AHORA</span>
      </button>

      {/* Urgencia y escasez */}
      <div className="text-center">
        <div className="bg-red-50 border border-red-200 rounded-xl p-4 mb-4">
          <div className="flex items-center justify-center mb-2">
            <i className="ri-time-line text-red-600 text-xl mr-2"></i>
            <span className="font-bold text-red-700">¡Últimas plazas disponibles!</span>
          </div>
          <div className="text-sm text-red-600">
            Esta oferta acabará pronto
          </div>
        </div>

        <div className="text-sm text-gray-500">
          <i className="ri-shield-check-line mr-1"></i>
          Acceso inmediato · Sin compromisos · Cancela cuando quieras
        </div>
      </div>
    </div>
  );
}
